import { isEmpty } from "lodash"
import { parseRef, scrubUndefined } from "../../firebase"

import { defaultListener, generateId } from '../helper'

export default {
  state: {
    divisions: {}
  },

  getters: {
    allDivisions(state) {
      return Object.values(state.divisions)
        .sort((a, b) => {
          return !!a.isArchived - !!b.isArchived
        })
    },
    getDivision: (state) => (id) => state.divisions[ id ] || {}
  },
  actions: {
    updateDivision({ getters }, data) {
      const { label, description, id, isArchived, location } = data

      const payload = { label, description, isArchived, location }
      const sessionTenant = getters.getSessionTenant
      const merge = true

      scrubUndefined(payload)

      console.log('updating', payload)

      this.$firebase.firestore()
        .collection('tenants')
        .doc(sessionTenant)
        .collection('divisions')
        .doc(id)
        .set(payload, { merge })
        .catch(e => console.log(e))
    },
    createDivision({ getters }, data) {
      const { label = '', description = '', isArchived = false, location = null } = data

      const payload = { label, description, isArchived, location }
      const sessionTenant = getters.getSessionTenant
      const merge = true

      const divisionId = generateId(sessionTenant, 'divisions')

      this.$firebase.firestore()
        .collection('tenants')
        .doc(sessionTenant)
        .collection('divisions')
        .doc(divisionId)
        .set(payload, { merge })
        .catch(e => console.log(e))
    },
    initDivisions({ getters, commit }) {
      const sessionTenant = getters.getSessionTenant

      this.$firebase.firestore()
        .collection('tenants')
        .doc(sessionTenant)
        .collection('divisions')
        .onSnapshot(defaultListener.bind(this, commit, 'ADD_DIVISION', 'REMOVE_DIVISION')
          , e => console.log(e))
    },
    ensureDivision({ getters, state, commit }, divisionId) {
      const division = state.divisions[ divisionId ] || {}

      const sessionTenant = getters.getSessionTenant

      if (isEmpty(division)) {
        this.$firebase.firestore()
          .collection('tenants')
          .set(sessionTenant)
          .collection('divisions')
          .doc(divisionId)
          .get()
          .then(ref => {
            const foundDivision = parseRef(ref)

            if (foundDivision) commit('ADD_DIVISION', foundDivision)
          })
          .catch(e => console.log(e))
      }
    }
  },
  mutations: {
    ADD_DIVISION(state, division) {
      const { id } = division

      if (id) {
        const newState = { ...state.divisions }
        newState[ id ] = division
        state.divisions = newState
      }
    },
    REMOVE_DIVISION(state, id) {
      if (state.divisions[ id ]) {
        const newState = { ...state.divisions }
        delete newState[ id ]
        state.divisions = newState
      }
    }
  },

}
